import { Typography, Box } from "@mui/material";
import { ContactInfoFields, AppConfigFields } from "../../types/appConfigEntities";
import {STYLES} from "../ShoppingCart/ShoppingCartStyles";

const storeInfoText = window.APP_CONFIG?.[AppConfigFields.ContactData]?.[ContactInfoFields.StoreInfo] || 
    "Local Mouchi - Uriburu 384, ONCE // CABA Horario de atención de lunes a viernes de 9 a 18, sábados de 9 a 13 hs";

export default function StoreInfo() {
  return (
    <Box sx={{ mb: 1 }}>
      <Typography
        sx={{
          mb: 1,
          fontFamily: "'Rubik', sans-serif",
          fontSize: "10px",
          textTransform: "uppercase",
          color: "#010101",
        }}
      >
        NUESTRO LOCAL
      </Typography>
      <Box sx={{ position: "relative", border: "1px solid #e0e0e0", p: 2 }}>
        <Typography
          sx={{
            fontSize: "12px",
            color: "#9e9e9e",
            fontFamily: "'Rubik', sans-serif",
            lineHeight: 1.5,
            pr: 4,
            maxWidth: "70%"
          }}
        >
          {storeInfoText }
        </Typography>

        <Box
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            px: 1,
            py: 0.5,
          }}
        >
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: 700,
              fontFamily: "'Rubik', sans-serif",
              color: STYLES.colors.secondary,
              textTransform: "uppercase",
            }}
          >
            GRATIS
          </Typography>
        </Box>
      </Box>
    </Box>
  );
}














